import 'reflect-metadata';
import { CompositeDisposable } from 'ts-disposables';
import { Container } from './container';
export function install(outerVue, outerOptions = {}) {
    // tslint:disable-next-line:variable-name no-shadowed-variable
    const Vue = outerVue;
    const options = outerOptions;
    return innerInstall(Vue, options);
}
// tslint:disable-next-line:no-shadowed-variable variable-name
function innerInstall(Vue, options) {
    if (!options.container) {
        (Vue.container = new Container()).makeGlobal();
    }
    else {
        Vue.container = options.container;
        Vue.container.makeGlobal();
    }
    function findContainer(instance) {
        if (instance.$container) {
            return instance.$container;
        }
        if (instance.$parent) {
            return findContainer(instance.$parent);
        }
        return Vue.container || Container.instance;
    }
    Vue.mixin({
        beforeCreate() {
            const createContainer = this.$options.createChildContainer;
            const disposable = this.__$disposable || new CompositeDisposable();
            this.__$disposable = disposable;
            const container = createContainer
                ? findContainer(this).createChild()
                : findContainer(this);
            if (this.$options.registerServices)
                this.$options.registerServices(container);
            Object.defineProperty(this, '$container', {
                configurable: false,
                enumerable: true,
                value: container,
                writable: false,
            });
            if (createContainer) {
                disposable.add(container);
            }
        },
        destroyed() {
            this.__$disposable.dispose();
        },
    });
}
//# sourceMappingURL=data:application/json;base64,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